import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import MainLogoNoText from '../assets/MainLogoNoText.png'; // the Halo Extravalanz logo
import '../CSS/NavScroll.css';

export function NavScroll() {
  return (
    <Navbar expand="lg" fixed="top" variant="dark" style={{
      backgroundColor: 'rgba(0,0,0,0)', 
      zIndex: 9999 // BOOST it way above your background
    }} className="px-3">
      <Container fluid>
        <Navbar.Brand as={Link} to="/">  {/* Link to Home page */}
          <img
            src={MainLogoNoText}
            width="60"
            height="60"
            className="d-inline-block align-top"
            alt="React Bootstrap logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0" style={{ color: 'white' }} navbarScroll>
            <NavDropdown title="league" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="/about">about</NavDropdown.Item> {/* Example link */}
              <NavDropdown.Item as={Link} to="/Standings">standings</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/squads">squads</NavDropdown.Item> {/* Example link */}
              <NavDropdown.Item as={Link} to="/roster">roster</NavDropdown.Item> {/* Example link */}
              <NavDropdown.Item as={Link} to="/captains">captains</NavDropdown.Item> {/* Example link */}
              <NavDropdown.Item as={Link} to="/faq">faq</NavDropdown.Item> {/* Example link */}
              <NavDropdown.Item as={Link} to="/donate">donate</NavDropdown.Item> {/* Example link */}
            </NavDropdown>
            <Nav.Link as={Link} to="/schedule">schedule</Nav.Link> {/* Example link */}
            <Nav.Link as={Link} to="/clothing">merch</Nav.Link>
          </Nav>
          <Nav.Item className="d-flex align-items-center">
            <a
              href="https://forms.gle/suQB47TeW1BJQY6w6"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-waitlist"
            >
              join waitlist
            </a>
          </Nav.Item>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
